import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '核心優勢', path: '/home/advantages' },
  { label: '合作流程', path: '/cooperation/process' },
  { label: '專業生產', path: '/about/production' },
  { label: '法規風險', path: '/about/regulation' },
];

const serviceItems = [
  { label: '熱銷配方', path: '/services/hot-formulas' },
  { label: '天然原料', path: '/services/natural-ingredients' },
  { label: '各類劑型', path: '/services/dosage-forms' },
  { label: '包材設計', path: '/services/packaging' },
];

const contactInfo = [
  {
    icon: 'ri-map-pin-line',
    label: '地址',
    value: '台中市北區中清路一段79號6樓',
    href: null,
  },
  {
    icon: 'ri-phone-line',
    label: '電話',
    value: '(04)-22029858',
    href: 'tel:04-22029858',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'natural1070606@gmail.com',
    href: 'mailto:natural1070606@gmail.com',
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a2e1a] text-white">
      {/* Main Content */}
      <div className="max-w-[1280px] mx-auto px-6 xl:px-10 py-16">
        <div className="footer-grid">
          {/* Column 1 - Brand Info */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/e260b0535e420cf4debd81c8e514ae3f.png"
                alt="康永生技 Logo"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 text-[0.9375rem] leading-relaxed">
              專業保健食品與生技產品<br />
              ODM / OEM 代工服務
            </p>
            <p className="text-gray-400 text-[0.875rem] leading-relaxed mt-4">
              康永以自然為本，用心協伴您<br />
              輕鬆打造品牌爆款產品
            </p>
            <p className="text-gray-300 text-[0.9375rem] leading-relaxed mt-3">
              統一編號: 50819218
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-[1.125rem] font-semibold text-white mb-5">關於康永</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 text-[0.9375rem] hover:text-white transition-colors duration-200 flex items-center gap-2 group cursor-pointer"
                  >
                    <span className="w-0 h-0.5 bg-white transition-all duration-200 group-hover:w-3 flex-shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-[1.125rem] font-semibold text-white mb-5">代工服務</h3>
            <ul className="space-y-3">
              {serviceItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-gray-300 text-[0.9375rem] hover:text-white transition-colors duration-200 flex items-center gap-2 group cursor-pointer"
                  >
                    <span className="w-0 h-0.5 bg-white transition-all duration-200 group-hover:w-3 flex-shrink-0" />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <h3 className="text-[1.125rem] font-semibold text-white mb-5">聯絡我們</h3>
            <ul className="space-y-4">
              {contactInfo.map((item) => (
                <li key={item.label} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[1.125rem] text-gray-300`} />
                  </div>
                  <div>
                    {item.href ? (
                      <a
                        href={item.href}
                        rel="nofollow"
                        className="text-gray-300 text-[0.875rem] hover:text-white transition-colors duration-200 cursor-pointer"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <span className="text-gray-300 text-[0.875rem]">{item.value}</span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 5 - LINE */}
          <div className="min-w-0">
            <h3 className="text-[1.125rem] font-semibold text-white mb-5">LINE 官方帳號</h3>
            <div className="flex flex-col items-start gap-3">
              {/* QR Code */}
              <a
                href="https://lin.ee/X7Hcpf4"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex-shrink-0 cursor-pointer"
                aria-label="掃描 QR Code 加入 LINE"
              >
                <img
                  src="https://storage.readdy-site.link/project_files/4ba0dab9-dd17-40bb-9c01-736e9bd30d9b/caddd531-3b1d-4c43-9423-d53ab0804cd5_L_gainfriends_2dbarcodes_GW.png?v=7268c853782cd8d95252096de5ccf381"
                  alt="康永生技 LINE QR Code"
                  className="w-[100px] h-[100px] object-contain rounded-lg bg-white p-1"
                />
              </a>
              {/* LINE Text Info */}
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-chat-smile-2-line text-[1rem] text-[#4ade80]" />
                  </div>
                  <span className="text-gray-300 text-[0.9375rem] font-medium">@126uwznp</span>
                </div>
                <p className="text-gray-400 text-[0.75rem] leading-relaxed mb-3">
                  掃描 QR Code 加入 LINE，<br className="hidden xl:block" />
                  立即洽詢 ODM / OEM 合作需求
                </p>
                <a
                  href="https://lin.ee/X7Hcpf4"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 bg-[#4ade80]/15 hover:bg-[#4ade80]/25 border border-[#4ade80]/40 text-[#4ade80] text-[0.8125rem] font-medium px-3 py-1.5 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-chat-smile-2-line text-[0.9375rem]" />
                  立即加入 LINE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-6 xl:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p className="text-gray-400 text-[0.8125rem] text-center sm:text-left">
              &copy; {currentYear} 康永生技有限公司 Kang Yong Biotech Ltd.
            </p>
            <span className="hidden sm:inline text-gray-600 text-[0.75rem]">|</span>
            <Link
              to="/privacy-policy"
              className="text-gray-400 text-[0.8125rem] hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              隱私政策
            </Link>
            <span className="hidden sm:inline text-gray-600 text-[0.75rem]">|</span>
            <Link
              to="/terms-of-use"
              className="text-gray-400 text-[0.8125rem] hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              使用條款
            </Link>
          </div>

        </div>
      </div>

      {/* Site Credit */}
      <div className="border-t border-white/5">
        <div className="max-w-[1280px] mx-auto px-6 xl:px-10 py-2.5 text-center">
          <span className="text-gray-500 text-[0.6875rem]">
            品牌官網建置｜{' '}
          </span>
          <a
            href="https://vpivip.com/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-gray-500 text-[0.6875rem] hover:text-gray-300 transition-colors duration-200 cursor-pointer"
          >
            天地人網整合行銷
          </a>
        </div>
      </div>
    </footer>
  );
}
